import {TextInputWithoutContainer} from "../../../../component/TextInput/TextInput";
import {Fragment} from "react";
import {capitalizeFirstLetter} from "../../../../assets/functions";
import Select, {SelectWithoutContainer} from "../../../../component/Select/Select";
import {minmaxPrice, printRefundAmount} from "../../functions";

const PricingForm = ({product, onChange}) => {
    const userLevels = [
        {
            persianLabel: "عادی",
            englishLabel: "normal",
        }, {
            persianLabel: "نقره ای",
            englishLabel: "silver",
        }, {
            persianLabel: "طلایی",
            englishLabel: "gold",
        },
    ];

    const refundMethodOptions = [
        {
            label : "هفتگی" ,
            value : "WEEKLY"
        },{
            label : "ماهانه" ,
            value : "MONTHLY"
        },{
            label : "هر دو ماه" ,
            value : "EVERY_TWO_MONTH"
        },{
            label : "هر سه ماه" ,
            value : "EVERY_THREE_MONTH"
        },{
            label : "هر چهار ماه" ,
            value : "EVERY_FOUR_MONTH"
        },{
            label : "هر شش ماه" ,
            value : "EVERY_SIX_MONTH"
        },{
            label : "سالانه" ,
            value : "YEARLY"
        },
    ];
    const changeSingleProductBalance = (index, value) => {
        const newSingleProducts = [...product.singleProducts];
        newSingleProducts[index].balance = value;

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);
    }
    const changeMinOrderLimitation = (index, value, userLevel) => {
        const newSingleProducts = [...product.singleProducts];
        const newLimitation = {...newSingleProducts[index].limitation};

        if (product.pricingMethod == "CONSTANT" || product.pricingMethod == "VARIABLE_MODEL") {
            newSingleProducts[index].limitation = {
                ...newLimitation,
                minOrderNumberForNormal: value,
                minOrderNumberForSilver: value,
                minOrderNumberForGold: value
            };
        } else if (product.pricingMethod == "VARIABLE_USER") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                newSingleProducts[i].limitation = {
                    ...newLimitation,
                    [`minOrderNumberFor${capitalizeFirstLetter(userLevel)}`]: value,
                };
            }
        } else if (product.pricingMethod == "VARIABLE") {
            newSingleProducts[index].limitation = {
                ...newLimitation,
                [`minOrderNumberFor${capitalizeFirstLetter(userLevel)}`]: value,
            };
        }

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);

    }
    const changeMaxOrderLimitation = (index, value, userLevel) => {
        const newSingleProducts = [...product.singleProducts];
        const newLimitation = {...newSingleProducts[index].limitation};

        if (product.pricingMethod == "CONSTANT" || product.pricingMethod == "VARIABLE_MODEL") {
            newSingleProducts[index].limitation = {
                ...newLimitation,
                maxOrderNumberForNormal: value,
                maxOrderNumberForSilver: value,
                maxOrderNumberForGold: value
            };
        } else if (product.pricingMethod == "VARIABLE_USER") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                newSingleProducts[i].limitation = {
                    ...newLimitation,
                    [`maxOrderNumberFor${capitalizeFirstLetter(userLevel)}`]: value,
                };
            }
        } else if (product.pricingMethod == "VARIABLE") {
            newSingleProducts[index].limitation = {
                ...newLimitation,
                [`maxOrderNumberFor${capitalizeFirstLetter(userLevel)}`]: value,
            };
        }

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);

    }
    const changeReturnProduct = (value, userLevel) => {
        const newProduct = {...product};
        if (product.pricingMethod == "CONSTANT" || product.pricingMethod == "VARIABLE_MODEL") {
            newProduct.returnProduct = {
                ...newProduct.returnProduct,
                maxHoursForNormal: value,
                maxHoursForSilver: value,
                maxHoursForGold: value,
            }
        } else if (product.pricingMethod == "VARIABLE_USER" || product.pricingMethod == "VARIABLE") {
            newProduct.returnProduct = {
                ...newProduct.returnProduct,
                [`maxHoursFor${capitalizeFirstLetter(userLevel)}`]: value,
            }
        }
        onChange(newProduct);

    }
    const changeAmount = (index, amount, userLevel) => {
        const newSingleProducts = [...product.singleProducts];

        const newPrice = {
            ...newSingleProducts[index].productPrices[`${userLevel}Price`],
            amount: amount,
            discountAmount: "",
            discountPercent: "",
        };

        if (product.pricingMethod == "CONSTANT") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    normalPrice: {...newPrice},
                    silverPrice: {...newPrice},
                    goldPrice: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE_MODEL") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                normalPrice: {...newPrice},
                silverPrice: {...newPrice},
                goldPrice: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        } else if (product.pricingMethod == "VARIABLE_USER") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    [`${userLevel}Price`]: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                [`${userLevel}Price`]: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        }

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);
    };
    const changeDiscountAmount = (index, discountAmount, userLevel) => {
        const newSingleProducts = [...product.singleProducts];

        const newPrice = {
            ...newSingleProducts[index].productPrices[`${userLevel}Price`],
            discountAmount: discountAmount,
            discountPercent: 100 - Math.ceil(discountAmount / newSingleProducts[index].productPrices[`${userLevel}Price`].amount * 100),
        };

        if (product.pricingMethod == "CONSTANT") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    normalPrice: {...newPrice},
                    silverPrice: {...newPrice},
                    goldPrice: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE_MODEL") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                normalPrice: {...newPrice},
                silverPrice: {...newPrice},
                goldPrice: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        } else if (product.pricingMethod == "VARIABLE_USER") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    [`${userLevel}Price`]: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                [`${userLevel}Price`]: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        }

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);
    }
    const changeDiscountPercent = (index, discountPercent, userLevel) => {
        const newSingleProducts = [...product.singleProducts];
        const newPrice = {
            ...newSingleProducts[index].productPrices[`${userLevel}Price`],
            discountAmount: discountPercent ? Math.floor(newSingleProducts[index].productPrices[`${userLevel}Price`].amount - (newSingleProducts[index].productPrices[`${userLevel}Price`].amount * discountPercent / 100)) : "",
            discountPercent: discountPercent,
        };

        if (product.pricingMethod == "CONSTANT") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    normalPrice: {...newPrice},
                    silverPrice: {...newPrice},
                    goldPrice: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE_MODEL") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                normalPrice: {...newPrice},
                silverPrice: {...newPrice},
                goldPrice: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        } else if (product.pricingMethod == "VARIABLE_USER") {
            for (let i = 0; i < newSingleProducts.length; i++) {
                const newProductPrices = {
                    ...newSingleProducts[i].productPrices,
                    [`${userLevel}Price`]: {...newPrice},
                };
                newSingleProducts[i].productPrices = newProductPrices;
            }
        } else if (product.pricingMethod == "VARIABLE") {
            const newProductPrices = {
                ...newSingleProducts[index].productPrices,
                [`${userLevel}Price`]: {...newPrice},
            };
            newSingleProducts[index].productPrices = newProductPrices;
        }

        const newProduct = {...product, singleProducts: [...newSingleProducts]}
        onChange(newProduct);
    }
    const getFinallyPrice = (price, rate) => {
        if (price.discountAmount)
            return price.discountAmount * rate;

        return price.amount * rate;

    }
    const changeInstallment = (key, value, userLevel) => {
        const newSingleProducts = [...product.singleProducts];
        const newInstallment = {...product.singleProducts[0].productPrices[`${userLevel}Installment`] , [key] : value} ;
        if (key == "minimumPrePaymentAmount")
            newInstallment.minimumPrePaymentPercent = "";
        else if (key == "minimumPrePaymentPercent" )
            newInstallment.minimumPrePaymentAmount = "";
        else if (key == "profitPercent")
            newInstallment.profitAmount = "";
        else if (key == "profitAmount")
            newInstallment.profitPercent = "";

        for (let i = 0; i < newSingleProducts.length ; i++)
            newSingleProducts[i].productPrices[`${userLevel}Installment`] = {...newInstallment};

        const newProduct = {...product, singleProducts: [...newSingleProducts]} ;
        onChange(newProduct);
    }



    return (
        <Fragment>
            <div className="col-12">
                {
                    product.pricingMethod == "CONSTANT" && <div className={"table-responsive"}>
                        <table className={'table text-center'}>
                            <thead>
                            <tr>
                                {product.singleProducts.length > 1 && <th></th>}
                                <th>تعداد موجود</th>
                                <th>حداقل تعداد خرید</th>
                                <th>حداکثر تعداد خرید</th>
                                <th>حداکثر ساعت عودت</th>
                                <th>قیمت</th>
                                <th>قیمت با تخفیف</th>
                                <th>درصد تخفیف</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                product.singleProducts.map((singleProduct, index) => {
                                        return (
                                            <tr key={index}>
                                                {product.singleProducts.length > 1 && <td width={'20%'}>
                                                    {singleProduct.color && <span
                                                        className={"d-block"}>رنگ: {singleProduct.color}</span>}
                                                    {singleProduct.size && <span
                                                        className={"d-block"}>سایز: {singleProduct.size}</span>}
                                                </td>}

                                                <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                             value={singleProduct.balance}
                                                                                             onChange={(value) => {
                                                                                                 changeSingleProductBalance(index, value);
                                                                                             }}/></td>

                                                <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                             value={singleProduct.limitation.minOrderNumberForNormal}
                                                                                             onChange={(value) => {
                                                                                                 changeMinOrderLimitation(index, value);
                                                                                             }}/></td>

                                                <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                             value={singleProduct.limitation.maxOrderNumberForNormal}
                                                                                             onChange={(value) => {
                                                                                                 changeMaxOrderLimitation(index, value);
                                                                                             }}/></td>


                                                {index == 0 &&
                                                    <td width={"10%"} rowSpan={Math.floor(product.singleProducts.length / 2)}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={product.returnProduct.maxHoursForNormal}
                                                                                   onChange={(value) => {
                                                                                       changeReturnProduct(value)
                                                                                   }}/></td>}

                                                {index == 0 && <Fragment>
                                                    <td rowSpan={Math.floor(product.singleProducts.length / 2)}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.amount}
                                                                                   onChange={(value) => {
                                                                                       changeAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>

                                                    <td rowSpan={Math.floor(product.singleProducts.length / 2)}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.discountAmount}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>


                                                    <td rowSpan={Math.floor(product.singleProducts.length / 2)}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.discountPercent}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountPercent(index, value, "normal")
                                                                                   }}/>
                                                    </td>


                                                </Fragment>
                                                }
                                                {index == Math.floor(product.singleProducts.length / 2) &&
                                                    <td className={"bg-secondary text-white"}
                                                        rowSpan={Math.floor(product.singleProducts.length / 2)}
                                                        colSpan={4}>
                                                        <span>{getFinallyPrice(singleProduct.productPrices.normalPrice, product.currency.rate).toLocaleString()} تومان</span>
                                                    </td>
                                                }
                                            </tr>
                                        )
                                    }
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                }
                {
                    product.pricingMethod == "VARIABLE_MODEL" && <div className={"table-responsive"}>
                        <table className={'table table-bordered text-center'}>
                            <thead>
                            <tr>
                                {product.singleProducts.length > 1 && <th></th>}
                                <th>تعداد موجود</th>
                                <th>حداکثر ساعت عودت</th>
                                <th>حداقل تعداد خرید</th>
                                <th>حداکثر تعداد خرید</th>
                                <th>قیمت</th>
                                <th>قیمت با تخفیف</th>
                                <th>درصد تخفیف</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                product.singleProducts.map((singleProduct, index) => {
                                        return (
                                            <Fragment key={index}>
                                                <tr>
                                                    {product.singleProducts.length > 1 &&
                                                        <td width={'20%'} rowSpan={2}>
                                                            {singleProduct.color && <span
                                                                className={"d-block"}>رنگ: {singleProduct.color}</span>}
                                                            {singleProduct.size && <span
                                                                className={"d-block"}>سایز: {singleProduct.size}</span>}
                                                        </td>}

                                                    <td width={"10%"} rowSpan={2}>
                                                        <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                                     value={singleProduct.balance}
                                                                                                     onChange={(value) => {
                                                                                                         changeSingleProductBalance(index, value);
                                                                                                     }}/></td>
                                                    </td>

                                                    {index == 0 && <td width={"10%"}
                                                                       rowSpan={product.singleProducts.length * 2}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={product.returnProduct.maxHoursForNormal}
                                                                                   onChange={(value) => {
                                                                                       changeReturnProduct(value)
                                                                                   }}/>
                                                    </td>}


                                                    <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                                 value={singleProduct.limitation.minOrderNumberForNormal}
                                                                                                 onChange={(value) => {
                                                                                                     changeMinOrderLimitation(index, value)
                                                                                                 }}/></td>

                                                    <td width={"10%"}><TextInputWithoutContainer type={"number"}
                                                                                                 value={singleProduct.limitation.maxOrderNumberForNormal}
                                                                                                 onChange={(value) => {
                                                                                                     changeMaxOrderLimitation(index, value)
                                                                                                 }}/></td>

                                                    <td width={"10%"}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.amount}
                                                                                   onChange={(value) => {
                                                                                       changeAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>

                                                    <td width={"10%"}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.discountAmount}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>
                                                    <td width={"10%"}>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices.normalPrice.discountPercent}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountPercent(index, value, "normal")
                                                                                   }}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className={"bg-secondary text-white text-center"}
                                                        rowSpan={1} colSpan={6}>
                                                        <span>{getFinallyPrice(singleProduct.productPrices.normalPrice, product.currency.rate).toLocaleString()} تومان</span>
                                                    </td>
                                                </tr>
                                            </Fragment>
                                        )
                                    }
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                }

                {product.pricingMethod == "VARIABLE_USER" && <div className={"table-responsive"}>
                    <table className={'table table-bordered text-center'}>
                        <thead>
                        <tr>
                            {product.singleProducts.length > 1 && <th></th>}
                            <th>تعداد موجود</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            product.singleProducts.map((singleProduct, index) => {
                                    return (
                                        <tr key={index}>
                                            {product.singleProducts.length > 1 && <td width={'15%'}>
                                                {singleProduct.color && <span
                                                    className={"d-block"}>رنگ: {singleProduct.color}</span>}
                                                {singleProduct.size && <span
                                                    className={"d-block"}>سایز: {singleProduct.size}</span>}
                                            </td>}

                                            <td width={"10%"}>
                                                <TextInputWithoutContainer type={"number"}
                                                                           value={singleProduct.balance}
                                                                           onChange={(value) => {
                                                                               changeSingleProductBalance(index, value);
                                                                           }}/>
                                            </td>


                                            {index == 0 && <td rowSpan={product.singleProducts.length}>
                                                <table className={"table table-borderless table-responsive"}>
                                                    <thead>
                                                    <tr>
                                                        <th width={"10%"}></th>
                                                        <th width={"10%"}>حداقل تعداد خرید</th>
                                                        <th width={"10%"}>حداکثر تعداد خرید</th>
                                                        <th width={"10%"}>حداکثر ساعت عودت</th>
                                                        <th>قیمت</th>
                                                        <th>قیمت با تخفیف</th>
                                                        <th width={"10%"}>درصد تخفیف</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {userLevels.map((userLevel, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>{userLevel.persianLabel}</td>
                                                                <td>
                                                                    <TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.limitation[`minOrderNumberFor${capitalizeFirstLetter(userLevel.englishLabel)}`]}
                                                                                               onChange={(value) => {
                                                                                                   changeMinOrderLimitation(index, value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>

                                                                <td>
                                                                    <TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.limitation[`maxOrderNumberFor${capitalizeFirstLetter(userLevel.englishLabel)}`]}
                                                                                               onChange={(value) => {
                                                                                                   changeMaxOrderLimitation(index, value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>

                                                                <td>
                                                                    <TextInputWithoutContainer type={"number"}
                                                                                               value={product.returnProduct[`maxHoursFor${capitalizeFirstLetter(userLevel.englishLabel)}`]}
                                                                                               onChange={(value) => {
                                                                                                   changeReturnProduct(value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>

                                                                <td>
                                                                    <TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.productPrices[`${userLevel.englishLabel}Price`].amount}
                                                                                               onChange={(value) => {
                                                                                                   changeAmount(index, value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>


                                                                <td><TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.productPrices[`${userLevel.englishLabel}Price`].discountAmount}
                                                                                               onChange={(value) => {
                                                                                                   changeDiscountAmount(index, value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>

                                                                <td>
                                                                    <TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.productPrices[`${userLevel.englishLabel}Price`].discountPercent}
                                                                                               onChange={(value) => {
                                                                                                   changeDiscountPercent(index, value, userLevel.englishLabel)
                                                                                               }}/>
                                                                </td>
                                                                <td className={"bg-secondary text-white"}>
                                                                    <span>{getFinallyPrice(singleProduct.productPrices[`${userLevel.englishLabel}Price`], product.currency.rate).toLocaleString()} تومان</span>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                    </tbody>
                                                </table>
                                            </td>
                                            }


                                        </tr>
                                    )
                                }
                            )
                        }
                        </tbody>
                    </table>
                </div>
                }

                {
                    product.pricingMethod == "VARIABLE" && <div className={"table-responsive"}>
                        <table className={'table table-bordered table-hover text-center'}>
                            <thead>
                            <tr>
                                {product.singleProducts.length > 1 && <th width={'10%'}></th>}
                                <th width={'10%'}>تعداد موجود</th>

                                <th width={'10%'}></th>
                                <th width={'10%'}>حداقل تعداد خرید</th>
                                <th width={'10%'}>حداکثر تعداد خرید</th>
                                <th width={'10%'}>حداکثر ساعت عودت</th>
                                <th>قیمت</th>
                                <th>قیمت با تخفیف</th>
                                <th width={'10%'}>درصد تخفیف</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                product.singleProducts.map((singleProduct, index) => {
                                        return (
                                            <Fragment>
                                                <tr key={index}>
                                                    {product.singleProducts.length > 1 &&
                                                        <td rowSpan={6}>
                                                            {singleProduct.color && <span
                                                                className={"d-block"}>رنگ: {singleProduct.color}</span>}
                                                            {singleProduct.size && <span
                                                                className={"d-block"}>سایز: {singleProduct.size}</span>}
                                                        </td>
                                                    }

                                                    <td rowSpan={6}><TextInputWithoutContainer type={"number"}
                                                                                               value={singleProduct.balance}
                                                                                               onChange={(value) => {
                                                                                                   changeSingleProductBalance(index, value);
                                                                                               }}/></td>

                                                    <td rowSpan={2}>عادی</td>

                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.minOrderNumberForNormal}
                                                                                   onChange={(value) => {
                                                                                       changeMinOrderLimitation(index, value, "normal")
                                                                                   }}/>
                                                    </td>


                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.maxOrderNumberForNormal}
                                                                                   onChange={(value) => {
                                                                                       changeMaxOrderLimitation(index, value, "normal")
                                                                                   }}/></td>

                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={product.returnProduct.maxHoursForNormal}
                                                                                   onChange={(value) => {
                                                                                       changeReturnProduct(value, "normal")
                                                                                   }}/></td>

                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["normalPrice"].amount}
                                                                                   onChange={(value) => {
                                                                                       changeAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>

                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["normalPrice"].discountAmount}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountAmount(index, value, "normal")
                                                                                   }}/>
                                                    </td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["normalPrice"].discountPercent}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountPercent(index, value, "normal")
                                                                                   }}/>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td colSpan={6} className={"bg-secondary text-white"}>
                                                        <span>{getFinallyPrice(singleProduct.productPrices["normalPrice"], product.currency.rate).toLocaleString()} تومان</span>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td rowSpan={2}>نقره ای</td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.minOrderNumberForSilver}
                                                                                   onChange={(value) => {
                                                                                       changeMinOrderLimitation(index, value, "silver")
                                                                                   }}/>
                                                    </td>


                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.maxOrderNumberForSilver}
                                                                                   onChange={(value) => {
                                                                                       changeMaxOrderLimitation(index, value, "silver")
                                                                                   }}/></td>

                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={product.returnProduct.maxHoursForSilver}
                                                                                   onChange={(value) => {
                                                                                       changeReturnProduct(value, "silver")
                                                                                   }}/></td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["silverPrice"].amount}
                                                                                   onChange={(value) => {
                                                                                       changeAmount(index, value, "silver")
                                                                                   }}/>
                                                    </td>

                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["silverPrice"].discountAmount}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountAmount(index, value, "silver")
                                                                                   }}/>
                                                    </td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["silverPrice"].discountPercent}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountPercent(index, value, "silver")
                                                                                   }}/>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan={6} className={"bg-secondary text-white"}>
                                                        <span>{getFinallyPrice(singleProduct.productPrices["silverPrice"], product.currency.rate).toLocaleString()} تومان</span>

                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td rowSpan={2}>طلایی</td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.minOrderNumberForGold}
                                                                                   onChange={(value) => {
                                                                                       changeMinOrderLimitation(index, value, "gold")
                                                                                   }}/>
                                                    </td>


                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.limitation.maxOrderNumberForGold}
                                                                                   onChange={(value) => {
                                                                                       changeMaxOrderLimitation(index, value, "gold")
                                                                                   }}/></td>
                                                    <td><TextInputWithoutContainer type={"number"}
                                                                                   value={product.returnProduct.maxHoursForGold}
                                                                                   onChange={(value) => {
                                                                                       changeReturnProduct(value, "gold")
                                                                                   }}/></td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["goldPrice"].amount}
                                                                                   onChange={(value) => {
                                                                                       changeAmount(index, value, "gold")
                                                                                   }}/>
                                                    </td>

                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["goldPrice"].discountAmount}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountAmount(index, value, "gold")
                                                                                   }}/>
                                                    </td>
                                                    <td>
                                                        <TextInputWithoutContainer type={"number"}
                                                                                   value={singleProduct.productPrices["goldPrice"].discountPercent}
                                                                                   onChange={(value) => {
                                                                                       changeDiscountPercent(index, value, "gold")
                                                                                   }}/>
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td colSpan={6} className={"bg-secondary text-white"}>
                                                        <span>{getFinallyPrice(singleProduct.productPrices["goldPrice"], product.currency.rate).toLocaleString()} تومان</span>
                                                    </td>
                                                </tr>


                                            </Fragment>
                                        )
                                    }
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                }
            </div>
            <div className="col-12">
                <label className="card-title my-4">فروش اقساط</label>
                <div className="table-responsive">
                <table className={"table table-bordered text-center"}>
                    <thead>
                    <tr>
                        <th></th>
                        <th>مبلغ پیش پرداخت</th>
                        <th width={"10%"}>درصد پیش پرداخت</th>
                        <th width={"15%"}>نحوه بازپرداخت</th>
                        <th width={"10%"}>حداکثر تعداد اقساط</th>
                        <th>مبلغ سود</th>
                        <th width={"10%"}>درصد سود</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        userLevels.map((userLevel, index) => {
                            return (
                                <Fragment key={index}>
                                    <tr>
                                        <td rowSpan={2}>کاربر {userLevel.persianLabel}</td>
                                        <td>
                                            <TextInputWithoutContainer type={"number"} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].minimumPrePaymentAmount}
                                                onChange={(value) => {
                                                    changeInstallment("minimumPrePaymentAmount" , value , userLevel.englishLabel);
                                                }}
                                            />
                                        </td>
                                        <td>
                                            <TextInputWithoutContainer type={"number"} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].minimumPrePaymentPercent}
                                                                       onChange={(value) => {
                                                                           changeInstallment("minimumPrePaymentPercent" , value , userLevel.englishLabel);
                                                                       }}
                                            />
                                        </td>
                                        <td>
                                            <SelectWithoutContainer options={refundMethodOptions} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].refundMethod} onChange={(value) => {
                                                changeInstallment("refundMethod" , value , userLevel.englishLabel)
                                            }} />
                                        </td>
                                        <td>
                                            <TextInputWithoutContainer type={"number"} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].maxNumberOfInstallment}
                                                                        onChange={(value) => {
                                                                            changeInstallment("maxNumberOfInstallment" , value , userLevel.englishLabel)
                                                                        }}/>
                                        </td>
                                        <td>
                                            <TextInputWithoutContainer type={"number"} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].profitAmount}
                                                                       onChange={(value) => {
                                                                           changeInstallment("profitAmount" , value , userLevel.englishLabel)
                                                                       }}/>
                                        </td>
                                        <td>
                                            <TextInputWithoutContainer type={"number"} value={product.singleProducts[0].productPrices[`${userLevel.englishLabel}Installment`].profitPercent}
                                                                       onChange={(value) => {
                                                                           changeInstallment("profitPercent" , value , userLevel.englishLabel)
                                                                       }}/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className={"bg-secondary text-white"} colSpan={6}>
                                            {printRefundAmount(product , userLevel.englishLabel , product.currency.rate)}
                                        </td>
                                    </tr>
                                </Fragment>
                            )
                                ;
                        })
                    }


                    </tbody>
                </table>
                </div>
            </div>
        </Fragment>
    );
}

export default PricingForm;